import axios from 'axios';
import { any } from 'prop-types';
import { AssignmentRules, RulesCondition, RulesObjects, RulesParameter, Ruleschapters, Rulesexams } from 'types/assignmentrules';

export const getAssignmentRule = async (id: any, setAssignmentRule: (val: AssignmentRules | undefined) => void) => {
    try {
        const response = await axios.get(`/get-assignment-rules-parameters?assignment_id=${id}`);
        const ruleschaptersData: AssignmentRules = response.data.data;

        setAssignmentRule(ruleschaptersData);
    } catch (error) {
        console.error(`error in getting product categories ${error}`);
    }
};

// export const getAssignmentRulesParameter = async (setAssignmentRulesParameter: (val: RulesParameter[]) => void) => {
//     try {
//         const response = await axios.get('/get-assignment-rules-parameters');
//         const rulesParameterData: RulesParameter[] = response.data.data.parameters;
//         setAssignmentRulesParameter(rulesParameterData);
//     } catch (error) {
//         console.error(`error in getting product categories ${error}`);
//     }
// };
// export const getAssignmentRuleschapters = async (id: any, setAssignmentRuleschapters: (val: Ruleschapters[]) => void) => {
//     try {
//         const response = await axios.get(`/get-assignment-rules-parameters?assignment_id=${id}`);
//         const ruleschaptersData: Ruleschapters[] = response.data.data.qustion_tags;

//         setAssignmentRuleschapters(ruleschaptersData);
//     } catch (error) {
//         console.error(`error in getting product categories ${error}`);
//     }
// };
// export const getAssignmentRulesexams = async (setAssignmentRulesexams: (val: Rulesexams[]) => void) => {
//     try {
//         const response = await axios.get('/get-assignment-rules-parameters');
//         const rulesExamData: Rulesexams[] = response.data.data.exams;
//         setAssignmentRulesexams(rulesExamData);
//     } catch (error) {
//         console.error(`error in getting product categories ${error}`);
//     }
// };

export const createRules = async (rules: any, onSuccess: (val: boolean) => void, setApicall: any) => {
    const body = { ...rules };
    setApicall(true);
    try {
        await axios
            .post('save-assignment-rules', body)
            .then((response) => {
                if (response.data === true) {
                    onSuccess(false);
                    setApicall(false);
                } else {
                    onSuccess(true);
                    setApicall(false);
                }
            })
            .catch((error) => {
                console.error(`error in create product ${error}`);
                onSuccess(false);
                setApicall(false);
            });
    } catch (error) {
        console.error(`error in create product ${error}`);
        onSuccess(false);
        setApicall(false);
    }
};

export const getAssignmentRules = async (
    id: any,
    setAssignmentRules: (val: RulesCondition[]) => void,
    setAssignmentRulesConditionData: (val: RulesObjects[]) => void,
    setStatus: (val: any) => void
) => {
    try {
        const response = await axios.get(`/get-assignment-rules?assignment_id=${id}`);
        const rulesExamData: RulesCondition[] = response.data.rules;
        const rulesConditionData: RulesObjects[] = response.data.rule_condition_data;
        const staus = response.data.status;
        setAssignmentRules(rulesExamData);
        setAssignmentRulesConditionData(rulesConditionData);
        setStatus(staus);
    } catch (error) {
        console.error(`error in getting product categories ${error}`);
    }
};

// export default getAssignmentRulesParameter;
